<div>
  <div class="success-graphic">
    <div>
      {{ "common.comp1" | translate }}
    </div>
  </div>
  <div class="success-content">
    <ng-container>
      <span>
        {{ "common.comp2" | translate }}
        {{ "common.thankyou" | translate }}
      </span>
    </ng-container>
    <button mat-flat-button mat-primary mat-dialog-close>
      {{ "success.close" | translate }}
    </button>
  </div>
</div>
